import React from 'react';
import './Disclaimer.css';
import { Link } from 'react-router-dom';

const Disclaimer = () => {
  return (
    <div className="disclaimer-container">
      <div className="disclaimer-header">
        <h1>Disclaimer & Terms of Use</h1>
      </div>

      <div className="disclaimer-content">
        <p>
          Our website <strong><Link to='/www.psjcapitalventures.com'>www.psjcapitalventures.com</Link></strong> provides a wide variety of online information and services related to stocks and investments, including content and applications which may be general or personalized in nature.
        </p>

        <p>
          The website is maintained and operated by PSJ Capital Ventures along with a team of affiliated institutions, agents, associates, and subsidiaries.
        </p>

        <p>
          By registering, accessing, or transmitting data through this website, you acknowledge that you have read, understood, and accepted the rights and obligations outlined in these Terms without any modification.
        </p>

        <p>
          We reserve the right to modify or amend these terms at any time without prior notice in order to protect both your and our interests.
        </p>

        <h2>Investment Disclaimer</h2>
        <p>
          The content, calls, and insights shared on this website are for **informational purposes only** and **do not constitute recommendations** to buy or sell any securities. Users who make investment decisions based on the content are solely responsible for their actions.
        </p>
        <p>
          The author may hold positions in the securities mentioned and disclaims any liability for direct or indirect losses arising from the use of this information.
        </p>

        <h2>External Links</h2>
        <p>
          This website may link to external websites or services. These external sites may have their own terms and conditions, and you may be required to accept additional rights and obligations. In case of any conflict between those and these terms, the current terms will prevail.
        </p>

        <h2>Acceptance and Termination</h2>
        <p>
          If you disagree with any part of this disclaimer or terms of use, we advise you to discontinue usage of this website or any of its services.
        </p>

        <h2>Risk of Loss</h2>
        <p>
          Investment in equities is subject to **market risk**, including potential loss of capital. Despite efforts to provide well-researched content, users should fully understand the risks involved before investing.
        </p>
      </div>
    </div>
  );
};

export default Disclaimer;
